import axios from "../../service/index"
import React, { Component } from "react"
import {Form, Input, Select, Divider, Switch, message, Radio, Button} from 'antd'
import Wangeditor from '../../commponents/wangeditor/index'
import "./index.less"
const FormItem = Form.Item;
class newDatum extends Component{
  constructor(props) {
		super(props)
    this.state = {
      modelTitle: '新建',
      collectType: 1,
      optionList: [],
      typeOption: [],
      editId: '',
      activeId: '',
      name: '',
      downloadType: '',
      info: {},
      isEdit: true,
      publish: false,
      informationDetails: '',
    }
  }
  componentDidMount() {
    this.props.form.setFieldsValue({
			// 'collectType': 1,
      'top': false,
		})
    this.getClassifyList()
    this.getSubjectList()
    if(this.props.location.state?.activeId){
      this.setState({activeId: Number(this.props.location.state.activeId), info:{materialsCategoryId: Number(this.props.location.state.activeId)}})
    }
    if(this.props.location.state?.id){
      this.setState({editId: this.props.location.state.id, modelTitle: '编辑'}, () => {
        this.infoList()
      })
    }
  }
  getClassifyList = () => {
    axios.get('/materialscategory/list').then(res => {
      if(res.data.code === '200'){
        this.setState({
          typeOption: res.data.data.data
        })
      }else{
        message.error(res.data.msg)
      }
    })
  }
  // handleOk = (e) => {
  //   e.preventDefault();
	// 	this.props.form.validateFields((err, values) => {
	// 		// console.log(values)
	// 		if (!err) {
  //     }
  //   })
  // }
  getSubjectList() {
		axios.get('subjectController/subjects/2').then( res => {
			if(res.data.code === '200') {
				let arr = res.data.data
				this.setState({
					optionList: arr
				})
			}
		})
	}
  infoList = () => {
    axios.get(`materials/info/${this.state.editId}`).then(res => {
      // console.log(res.data.data)
      if(res.data.code === '200'){
        let data = res.data.data
        this.setState({
          info: res.data.data,
          downloadType: data.downloadType,
          downloadUrl: data.downloadType === 2?data.path:data.downloadUrl,
          collectType: data.collectType,
          informationDetails: data.informationDetails,
          publish: data.publish === 1?true:false
        })
        this.props.form.setFieldsValue({
          'top': res.data.data.top === 1?true:false,
          'informationDetails':  data.informationDetails
        })
      }else{
        message.error(res.data.msg)
      }
    })
  }
  closeModel = () => {
    localStorage.setItem('tab', this.state.activeId)
    this.props.history.push('/datumSquare')
  }
  handleOk = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      console.log(values)
      if(!err){
        let params = {
          id: this.state.modelTitle === '编辑'?this.state.editId:'',
          materialsCategoryId: this.state.activeId,
          name: values.name,
          appid: values.appid||'',
          downloadType: values.downloadType,
          path: values.downloadType === 2?values.downloadUrl:'',
          downloadUrl: values.downloadType !== 2?values.downloadUrl:'',
          collectType:values.collectType,
          assistancePeople: values.assistancePeople||0,
          subjectId: values.subjectId,
          informationDetails: values.informationDetails,
          preCollectNum: values.preCollectNum,
          top: values.top?1:0,
          publish: this.state.publish?1:0
        }
        let url = this.state.modelTitle === '新建'?'materials/add':'materials/update'
        axios.post(url, params).then(res => {
          console.log(res)
          if(res.data.code === '200'){
            message.success(res.data.msg)
            this.props.form.resetFields()
            localStorage.setItem('tab', this.state.activeId)
            this.props.history.push('/datumSquare')
          }else{
            message.error(res.data.msg)
          }
        })
      }
    })
  }
  getText = v => {
		// console.log(v)
		this.props.form.setFieldsValue({
			'informationDetails': v
		});
	}
  render() {
    const {modelTitle, informationDetails, info, downloadType, publish, collectType, downloadUrl} = this.state
    const { getFieldDecorator } = this.props.form;
    return (
        <div className="datum-wrap">
          <div className="header-between">
          <span className="header-name">{modelTitle}资料</span>
          <span className="my-button-txt" onClick={()=>{
              this.props.history.push('/datumSquare')
            }}>返回上一级</span>
          </div>
          <Divider />
          <Form labelCol={{ span: 3 }} wrapperCol={{ span: 12 }} autoComplete="off" onSubmit={this.handleOk}>
            <FormItem label={"资料分类"} key={0}>
              {getFieldDecorator('materialsCategoryId', {
                rules: [{ required: true, message: '请选择资料分类!', }],
                initialValue:info.materialsCategoryId || ''
              })(
                <Select placeholder="请选择资料分类" onChange={(e) => {this.setState({activeId: e})}}>
                  {this.state.typeOption.map(item=>{
                    return (<Select.Option key={item.id+item.name} value={item.id}>{item.name}</Select.Option>)
                  })}
                </Select>
              )}
            </FormItem>
            <FormItem label={"资料名称"}>
              {getFieldDecorator('name', {
                rules: [{ required: true, message: '请输入资料名称!', }],
                initialValue:modelTitle==='编辑'? info.name: ''
              })(
                <Input placeholder='请输入资料名称' />
              )}
            </FormItem>
            <div className="zip-form">
              <div className="zip-title"><span>*</span> 资料链接 : </div>
            <FormItem label={""}>
              {getFieldDecorator('downloadType', {
                rules: [{ required: true, message: '请输入资料链接!', }],
                initialValue:modelTitle==='编辑'? info.downloadType: ''
              })(
                  <Select onChange={(val) => {
                    this.setState({
                      downloadType: val
                    })
                  }} placeholder="请选择" className="zip-width">
                    <Select.Option value={0}>小程序内部链接</Select.Option>
                    <Select.Option value={1}>H5链接</Select.Option>
                    <Select.Option value={2}>第三方小程序链接</Select.Option>
                  </Select>
              )}
            </FormItem>
            {
              downloadType === 2?
            <FormItem label="">
              {getFieldDecorator('appid', {
                rules: [{ required: true, message: '请输入appid!', }],
                initialValue:modelTitle==='编辑'? info.appid: ''
              })(
                <Input style = { {height: '40px' }} className="zip-width" placeholder='请输入AppId' allowClear maxLength={50}/>
              )}
            </FormItem>
            :''}
            <FormItem label="">
              {getFieldDecorator('downloadUrl', {
                rules: [{ required: true, message: '请输入资料链接!', }],
                initialValue:modelTitle==='编辑'? downloadUrl: ''
              })(
                <Input placeholder='请输入链接' allowClear style={{height: '40px'}} />
              )}
            </FormItem>
            </div>
            <Form.Item label="领取方式" className="collectType" >
              {getFieldDecorator('collectType', {
                rules: [{ required: true, message: '请选择领取方式!' }],
                initialValue: modelTitle==='编辑'? info.collectType: 1,
              })(
                <div>
                  <Radio.Group value={collectType} disabled={modelTitle === '编辑'?true:false} onChange={(e)=>{this.setState({collectType: e.target.value})}} >
                    <Radio value={0}>助力领取</Radio>
                    <Radio value={1}>不助力领取</Radio>
                  </Radio.Group>
                </div>
              )}
            </Form.Item>
            {collectType === 0?<FormItem label={"需要助力人数"}>
              {getFieldDecorator('assistancePeople', {
                rules: [{required: true, message: '请输入需要助力人数'}],
                initialValue:modelTitle==='编辑'? info.assistancePeople: 0
              })(
                <Input placeholder='请输入需要助力人数' type="number" min={0}/>
              )}
            </FormItem>:''}
            <Form.Item label="所属学科">
              {getFieldDecorator('subjectId', {
                rules: [{ required: true, message: '请选择所属学科' }],
                initialValue:modelTitle==='编辑'? info.subjectId: ''
              })(
                <Select placeholder="请选择所属学科">
                  {this.state.optionList.map(item=>{
                    return (<Select.Option key={item.subjectId+item.subjectName} value={item.subjectId}>{item.subjectName}</Select.Option>)
                  })}
                </Select>
              )}
            </Form.Item>
            <Form.Item label="资料详情" className="tum-detail">
              {getFieldDecorator('informationDetails', {
                rules: [{ required: true, message: '请输入资料详情' }],
                initialValue:modelTitle==='编辑'? info.informationDetails: ''
              })(
                <Wangeditor content={informationDetails} getText={this.getText} />
              )}
            </Form.Item>
            <FormItem label={"预设领取人数"}>
              {getFieldDecorator('preCollectNum', {
                initialValue:modelTitle==='编辑'? info.preCollectNum: ''
              })(
                <Input style = { {height: '40px' }} placeholder='请输入预设领取人数' type="number" min={0}/>
              )}
            </FormItem>

            <Form.Item label={"是否置顶"}>
              {getFieldDecorator('top', {
                valuePropName: 'checked',
              })(
                <Switch />
              )}
            </Form.Item>
            {publish===true}
            <Form.Item label={"发布资料"}>
              {getFieldDecorator('publish', {
                initialValue:modelTitle==='编辑'? publish: ''
              })(
                <div>
                  
                  <Switch checked={publish} onChange={(e) => {this.setState({publish: e})}} />
                  <span className="form-text">资料发布后用户端可见</span>
                </div>
              )}
            </Form.Item>
            <Form.Item style={{textAlign: 'center', marginTop: '40px'}}>
              <Button onClick={this.closeModel}>取消</Button>
              <Button style={{ marginLeft: 8 }} type="primary" htmlType="submit">确定</Button>
						</Form.Item>
          </Form>
        </div>
    )
  }
}
export default Form.create()(newDatum)